export const TEXTS = {
    SHOW_MORE_CTA: `View all UPI options`,
};
